<template>
  <div class="layer">
    <div class="contentCal">
      <table border="1">
        <tr>
          <th colspan="14" style="background: #f5fafa; height: 100px; text-align: center">
            <h2 style="font-size: 24px">{{ data.monomerName }}</h2>
          </th>
        </tr>
        <tr>
          <td colspan="2" style="background: #f5fafa; text-align: right">
            行政区域:
          </td>
          <td colspan="5" style="text-align: left; word-break: break-all">
            {{ data.areaName }}
          </td>
          <td colspan="2" style="background: #f5fafa; text-align: right">
            类 别:
          </td>
          <td colspan="5" style="text-align: left; word-break: break-all">
            {{ data.mainTypeName }} - {{ data.subtypeName }} -
            {{ data.basicTypeName }}
          </td>
        </tr>
        <tr>
          <td colspan="2" style="background: #f5fafa; text-align: right">
            填 表 人:
          </td>
          <td colspan="5" style="text-align: left">
            {{ data.filledBy }}
          </td>
          <td colspan="2" style="background: #f5fafa; text-align: right">
            描 述:
          </td>
          <td colspan="5" style="text-align: left; word-break: break-all">
            {{ data.otherInstructionsOne }}
          </td>
        </tr>
        <tr>
          <td colspan="2" style="background: #f5fafa; text-align: right">
            代 码:
          </td>
          <td colspan="5" style="text-align: left; word-break: break-all">
            {{ data.code }}
          </td>
          <td colspan="2" style="background: #f5fafa; text-align: right">
            行政位置:
          </td>
          <td colspan="5" style="text-align: left; word-break: break-all">
            {{ data.administrativeLocation }}
          </td>
        </tr>
        <tr>
          <td colspan="2" style="background: #f5fafa; text-align: right">
            手 机 号:
          </td>
          <td colspan="5" style="text-align: left; word-break: break-all">
            {{ data.contactNumber }}
          </td>
          <td colspan="2" style="background: #f5fafa; text-align: right">
            级 别:
          </td>
          <td colspan="5" style="text-align: left; word-break: break-all">
            {{ data.maybeGrade }}
          </td>
        </tr>
        <tr>
          <td colspan="2" style="background: #f5fafa; text-align: right">
            经 度:
          </td>
          <td colspan="5" style="text-align: left; word-break: break-all">
            {{ data.longitude }}
          </td>
          <td colspan="2" style="background: #f5fafa; text-align: right">
            纬 度:
          </td>
          <td colspan="5" style="text-align: left; word-break: break-all">
            {{ data.latitude }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['layerid', 'data'],
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style lang="less" scoped>
.layer {
  width: 100%;
  height: 100%;
  .contentCal {
    overflow-y: auto;
    padding: 10px;
    table {
      border-collapse: collapse;
      text-align: center;
      table-layout: fixed;
      width: 100%;
      background-color: white;
    }
    table td,
    table th {
      border: 1px solid #cad9ea;
      color: #666;
      height: 40px;
    }
    table thead th {
      background-color: #cce8eb;
      width: 100px;
    }
    table tr:nth-child(odd) {
      background: #fff;
    }
    table tr td {
      font-size: 15px;
      color: #657180;
      padding: 0 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/leftmenu/layers/menuLayerTreePup.vue